var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMyChallengesOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2315 22.8481L33.0894 21.9938H31.8787H6.5C5.94575 21.9938 5.5 21.5469 5.5 21C5.5 20.4531 5.94575 20.0062 6.5 20.0062H31.8787H33.0894L32.2315 19.1519L25.2462 12.1957C24.8567 11.8078 24.8567 11.1797 25.2462 10.7918C25.6369 10.4027 26.2712 10.4027 26.6619 10.7918L36.2078 20.298C36.5974 20.686 36.5974 21.314 36.2078 21.702L26.6619 31.2082C26.2712 31.5973 25.6369 31.5973 25.2462 31.2082C24.8567 30.8203 24.8567 30.1922 25.2462 29.8043L32.2315 22.8481Z",
    fill: "black",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyChallengesOutlined);
export default __webpack_public_path__ + "static/media/icon-myChallenges-outlined.2d1066a02ca8f7ca599823868fb66d22.svg";
export { ForwardRef as ReactComponent };